var resources = require('itemsViewStrings');
    var strings = resources['_cMfBzi6mKGnu8kK3P3DTjw'];
export { strings };
export default strings;
